module.exports = __webpack_public_path__ + "img/iconQuotes.bf7f9758.svg";